import { AppConfigStateInterface } from './interfaces';

export const appConfigInitialState: AppConfigStateInterface = {
  isReady: false,
  drawWrapper: false,
  isPreloaded: false,
  isAppPreloaded: false,
};
